import React from 'react'
import {
  COLOR_ONE,
  COLOR_TWO,
  COLOR_THREE,
  COLOR_FOUR,
  COLOR_FIVE,
  COLOR_SIX,
  COLOR_SEVEN,
} from './eventColors'

const EventFilterButtons = (props) => {
  const { filter } = props;

  const filters = [
    'all',
    'awards',
    'community_outreach',
    'dignitary_meetings',
    'interviews',
    'keynote_speech',
    'videos',
    'volunteer_work',
  ];

  const buttons = filters.map((f, i) => {
    let buttonText = '';

    switch(f) {
      case 'all':
        buttonText = 'All';
        break;
      case 'volunteer_work':
        buttonText = 'Volunteer Work';
        break;
      case 'awards':
        buttonText = 'Awards';
        break;
      case 'community_outreach':
        buttonText = 'Community Outreach';
        break;
      case 'dignitary_meetings':
        buttonText = 'Dignitary Meetings';
        break;
      case 'keynote_speech':
        buttonText = 'Keynote Speeches';
        break;
      case 'interviews':
        buttonText = 'Interviews';
        break;
      case 'videos':
        buttonText = 'Videos';
      default:
        break;
    }

    const buttonClass = `button-${f.replace('_', '-')}`;

    return (
      <button
        key={i}
        onClick={(e) => props.onFilter(e, f)}
        className={
          f === filter
            ? `active ${buttonClass}`
            : buttonClass
        }
      >
        {buttonText}
      </button>
    );
  });

  return (
    <div className="event-filter-buttons">
      {buttons}
    </div>
  );
};

export default EventFilterButtons;
